import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput,
    Table
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"
import moment from 'moment'

import { Link, useHistory, Redirect } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'
import Shimmer from "react-shimmer-effect";
import CustomSelect from "../../../../helpers/ui/CustomSelect"

import UpdateBloc from './Blocs/UpdateBloc'

class IndexView extends Component {

    updateBloc = new UpdateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            totalRow : null,
            punishmentOptions: []
        }
    }

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
          res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    reformatOptions = function(raw, label, value) {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = data[label];
          newObj["value"] = data[value];
      
          return newObj;
        });
    };

    submitData = async () => {
        // const formData = generateFormData(this.state.dataForm, 'file_sk') // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        const formData = generateFormData(this.state.dataForm, ['file_sk','file_bap','file_lhp']) // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        await this.updateBloc.fetchUpdatedokumen(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                uuid: this.state.detail?.punishment_discipline_uuid,
                ...values
            },
            confirm: true
        })
        console.log(values)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.updateBloc.updateDokumenChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            detail: response
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.updateBloc.punishmentChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        
                        this.setState({
                            punishmentOptions: this.reformatOptions(
                                response.result, 
                                'punishment_name',
                                'punishment_uuid'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.updateBloc.fetchPunishment({is_tunkin: 1})

        const queryParams = new URLSearchParams(this.props.location.search)
        this.updateBloc.fetchDetail({uuid: queryParams.get('uuid') })
    }

    componentWillUnmount() {
        this.updateBloc.updateChannel?.unsubscribe()
        this.updateBloc.detailChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <CardTitle>Upload SK Hukuman Disiplin</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                # Pegawai Terkena Hukuman
                                            </label>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                NIP
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_employee_nip !== "" ? this.state.detail.punishment_discipline_employee_nip : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Nama
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_employee_name !== "" ? this.state.detail.punishment_discipline_employee_name : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Pangkat
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_pangkat_golongan !== "" ? this.state.detail.employee_pangkat_golongan : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Jabatan
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_employee_position !== "" ? this.state.detail.punishment_discipline_employee_position : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Unit Kerja
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_employee_work_unit !== "" ? this.state.detail.punishment_discipline_employee_work_unit : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        <hr />

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                # Atasan langsung
                                            </label>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                NIP
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_head_employee_nip !== "" ? this.state.detail.punishment_discipline_head_employee_nip : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Nama
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_head_employee_name !== "" ? this.state.detail.punishment_discipline_head_employee_name : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Pangkat
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.head_pangkat_golongan !== "" ? this.state.detail.head_pangkat_golongan : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Jabatan
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_head_employee_position !== "" ? this.state.detail.punishment_discipline_head_employee_position : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        <hr />

                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Rekomendasi Hukuman
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.detail ?
                                                            <>{this.state.detail.punishment_discipline_punishment_name !== "" ? this.state.detail.punishment_discipline_punishment_name : '-'}</>
                                                        : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Keputusan Hukuman Berdasarkan Hasil Pemeriksaan
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.detail ?
                                                            <>{this.state.detail.punishment_discipline_result_punishment_name !== "" ? this.state.detail.punishment_discipline_result_punishment_name : '-'}</>
                                                        : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Keterangan Hasil Pemeriksaan
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.detail ?
                                                            <>{this.state.detail.punishment_discipline_result_description !== "" ? this.state.detail.punishment_discipline_result_description : '-'}</>
                                                        : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>

                                        <hr />

                                        {/* <Row className="mb-3">
                                            <label className="col-md-3">
                                                Hasil Akhir Keputusan Hukuman <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <CustomSelect 
                                                    name="punishment_discipline_result_final_punishment_uuid"
                                                    errorMessage="Pilih Keputusan Hukuman"
                                                    options={this.state.punishmentOptions} 
                                                    placeholder="Pilih Keputusan Hukuman"
                                                    defaultValue={this.state.detail?.punishment_discipline_result_punishment_uuid}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Keterangan Hasil Akhir Keputusan Hukuman <span className="text-danger">*</span>
                                            </label>
                                            <Col md="8">
                                            <AvField
                                                    name="punishment_discipline_result_final_description"
                                                    placeholder="Keterangan Hasil Akhir Keputusan Hukuman" Akhir
                                                    errorMessage="Masukkan Keterangan Hasil Akhir Keputusan Hukuman" Akhir
                                                    type="textarea"
                                                    className="form-control"
                                                    // value={this.state.detail?.punishment_discipline_result_final_description}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row> */}

                                        {/* <hr />

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor SK Hukuman <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                 <AvField
                                                    name="punishment_discipline_sk_number"
                                                    id="punishment_discipline_sk_number"
                                                    placeholder="Nomor SK Hukuman"
                                                    type="text"
                                                    errorMessage="Masukan Nomor SK Hukuman"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    // value={this.state.dataForm?.punishment_discipline_sk_number}
                                                />
                                            </Col>
                                        </Row>   */}

                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="punishment_discipline_sk_date"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal SK Hukuman <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                 <AvField
                                                    name="punishment_discipline_sk_date"
                                                    id="punishment_discipline_sk_date"
                                                    placeholder="Tanggal SK Hukuman"
                                                    type="date"
                                                    errorMessage="Masukan Tanggal SK Hukuman"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    // value={this.dateParseYMD(this.state.dataForm?.punishment_discipline_sk_date)}
                                                />
                                            </Col>
                                        </Row>     */}

                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            TMT SK Hukuman <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                 <AvField
                                                    name="punishment_discipline_sk_tmt_date"
                                                    id="punishment_discipline_sk_tmt_date"
                                                    placeholder="TMT SK Hukuman"
                                                    type="date"
                                                    errorMessage="Masukan TMT SK Hukuman"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    // value={this.dateParseYMD(this.state.dataForm?.punishment_discipline_sk_tmt_date)}
                                                />
                                            </Col>
                                        </Row>    */}

                                        {/* <Row className="mb-3">
                                            <label className="col-md-3">
                                                Upload SK Hukuman Disiplin <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                <FileInput
                                                    name="file_sk"
                                                    col="4"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row> */}
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Upload BAP <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                <FileInput
                                                    name="file_bap"
                                                    col="4"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Upload LHP <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                <FileInput
                                                    name="file_lhp"
                                                    col="4"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <AvField
                                            name={`working_hours_day_name`}
                                            type="hidden"
                                        />

                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="?">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/hukuman_disiplin.html?'/>
                : null }
            </Fragment>
        )
    }

}

//export default IndexView
export default withRouter(IndexView);